import React from 'react';
import BarsContainer from '../../containers/barsContainer';
import Home from '../../containers/home';
import Details from '../../containers/details';
import ChartCompare from '../../containers/chartCompare/index';
import ChartCompareSenate from '../../containers/chartCompareSenate/index';
import { TYPES } from '../../envs/core';
import {
  getModuleAmp,
  getModuleWeb,
  MODULE_TYPES
} from '../moduleGenerator/utils';
import Pactometro from '../pactometro';
import Card from '../../components/card';
import RankingPactometro from '../rankingPactometro';
import MiniPactometro from '../miniPactometro';

const getAMPHeight = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.RESULTADOS:
      switch (electionType) {
        case TYPES.GENERAL:
          return location && location.typePlace === "TOWN"
            ? 1100 //Detalle
            : 1100; //Resultados;
        case TYPES.REGIONAL:
          return location.typePlace === "TOWN"
            ? "detalleAutonomica"
            : "resultadosautonomicos";
        case TYPES.MUNICIPAL:
          return location.typePlace === "TOWN"
            ? "detalleMunicipal"
            : "resultadosmunicipales";
        case TYPES.EUROPEAN:
          return location.typePlace === "TOWN"
            ? "detalleEuropeas"
            : "resultadosEuropeas";
        default:
          throw new Error("Error");
      }
    case MODULE_TYPES.PACTOMETRO:
      return 680; //pactometro;
    case MODULE_TYPES.ARCO:
      return 320; //graficas;
    case MODULE_TYPES.BARRAS:
      return 340; //bars;
    case MODULE_TYPES.RANKING:
      return 1100; //rankingPactometro;
    case MODULE_TYPES.MINI:
      return 400; //miniPactometro;
    case MODULE_TYPES.ARCO_SENADO:
      return 320; //senate;
    default:
      throw new Error("Error");
  }
};

const getHtmlName = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.RESULTADOS:
      switch (electionType) {
        case TYPES.GENERAL:
          return location && location.typePlace === 'TOWN'
            ? 'detalle'
            : 'resultados';
        case TYPES.REGIONAL:
          return location.typePlace === 'TOWN'
            ? 'detalleAutonomica'
            : 'resultadosautonomicos';
        case TYPES.MUNICIPAL:
          return location.typePlace === 'TOWN'
            ? 'detalleMunicipal'
            : 'resultadosmunicipales';
        case TYPES.EUROPEAN:
          return location.typePlace === 'TOWN'
            ? 'detalleEuropeas'
            : 'resultadosEuropeas';
        default:
          throw new Error('Error');
      }
    case MODULE_TYPES.PACTOMETRO:
      return 'pactometro';
    case MODULE_TYPES.ARCO:
      return 'graficas';
    case MODULE_TYPES.BARRAS:
      return 'bars';
    case MODULE_TYPES.RANKING:
      return 'rankingPactometro';
    case MODULE_TYPES.MINI:
      return 'miniPactometro';
    case MODULE_TYPES.ARCO_SENADO:
      return 'senate';
    default:
      throw new Error('Error');
  }
};

const getLocationPath = (type, location) => {
  switch (type) {
    case TYPES.REGIONAL:
      switch (location.typePlace) {
        case 'TOWN':
          return `${location.grandpaId}/${location.parentId}/${location.ineId}`;
        case 'PROVINCE':
          return `${location.parentId}/${location.ineId}`;
        default:
          return location.ineId;
      }
    case TYPES.GENERAL:
      switch (location.typePlace) {
        case 'TOWN':
          return `${location.parentId}/${location.ineId}`;
        case 'PROVINCE':
          return `${location.parentId}/${location.ineId}`;
        default:
          return location.ineId;
      }
    case TYPES.EUROPEAN:
    case TYPES.MUNICIPAL:
      return location.ineId;
    default:
      throw new Error('Error');
  }
};

const getUrl = (type, electionType, location, navegable) => {
  if (electionType !== TYPES.GENERAL) {
    return `/1/${navegable ? '1' : '0'}/2019/2/${getLocationPath(
      electionType,
      location
    )}/${getHtmlName(type, electionType, location)}.html`;
  } else if (location) {
    return `/C108/${navegable ? '1' : '0'}/2019/GENERAL/2/${getLocationPath(
      electionType,
      location
    )}/${getHtmlName(type, electionType, location)}.html`;
  } else {
    return `/C108/${navegable ? '1' : '0'}/2019/GENERAL/2/${getHtmlName(
      type,
      electionType,
      location
    )}.html`;
  }
};

const Module = data => {
  const { type, electionType, location, navegable } = data;
  const moduleId = 'elections_module_' + new Date().getTime();
  const url = getUrl(type, electionType, location, navegable);
  const moduleWeb = getModuleWeb(moduleId, url);
  const moduleHeight = getAMPHeight(type, electionType, location, navegable);
  const moduleAmp = getModuleAmp(url, moduleHeight);

  var provindeId;
  var communityId;
  var townId;

  if (location) {
    switch (location.typePlace) {
      case 'REGION':
        provindeId = location.ineId;
        break;
      case 'PROVINCE':
        communityId = location.parentId;
        provindeId = location.ineId;
        break;
      case 'TOWN':
        provindeId = location.parentId;
        townId = location.ineId;
        break;
      default:
        return;
    }
  }

  const match = {
    params: {
      year: '2019',
      type: 'GENERAL',
      electionNumber: '2',
      placesIds: 'C108',
      province: provindeId,
      community: communityId,
      town: townId
    }
  };

  return (
    <div>
      <Card title="Vista previa" className="vistaprevia" isCollapsed="true">
        {type === MODULE_TYPES.ARCO_SENADO && (
          <ChartCompareSenate match={match} />
        )}
        {type === MODULE_TYPES.ARCO && <ChartCompare match={match} />}
        {type === MODULE_TYPES.BARRAS && <BarsContainer match={match} />}
        {type === MODULE_TYPES.RESULTADOS &&
          (!location || (location && location.typePlace !== 'TOWN')) && (
            <Home match={match} />
          )}
        {type === MODULE_TYPES.RESULTADOS &&
          location &&
          location.typePlace === 'TOWN' && <Details match={match} />}
        {type === MODULE_TYPES.PACTOMETRO && <Pactometro match={match} />}
        {type === MODULE_TYPES.RANKING && <RankingPactometro match={match} />}
        {type === MODULE_TYPES.MINI && <MiniPactometro match={match} />}
      </Card>

      <Card title="Módulos" className="vistaprevia">
        <div className="two">
          <h3>Módulo web</h3>
          <textarea readOnly value={moduleWeb} />
        </div>
        <div className="two">
          <h3>Módulo AMP</h3>
          <textarea readOnly value={moduleAmp} />
        </div>
      </Card>
    </div>
  );
};

export default Module;
